import { ticketType } from "@agentcall/core/type"
import { ChevronDown } from "react-feather"
import type { TicketGet200TicketStatus } from "@/api/client/ticket"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface TicketStatusDropdownProps {
  currentStatus: TicketGet200TicketStatus
  onStatusChange: () => void
  disabled?: boolean
}

const getStatusLabel = (status: string): string => {
  const statusItem = ticketType.TICKET_STATUSES.find((item) => item.key === status)
  return statusItem?.value || status
}

const statusConfig: Record<TicketGet200TicketStatus, { label: string; className: string }> = {
  oc_in_progress: {
    label: getStatusLabel("oc_in_progress"),
    className: "bg-yellow-500 hover:bg-yellow-600",
  },
  owner_in_progress: {
    label: getStatusLabel("owner_in_progress"),
    className: "bg-red-500 hover:bg-red-600",
  },
  contractor_in_progress: {
    label: getStatusLabel("contractor_in_progress"),
    className: "bg-blue-500 hover:bg-blue-600",
  },
  completed: { label: getStatusLabel("completed"), className: "bg-green-500 hover:bg-green-600" },
}

export function TicketStatusDropdown({
  currentStatus,
  onStatusChange,
  disabled = false,
}: TicketStatusDropdownProps) {
  const config = statusConfig[currentStatus] || statusConfig.oc_in_progress

  return (
    <Button
      variant="default"
      size="sm"
      className={cn("gap-1", config.className)}
      disabled={disabled}
      onClick={onStatusChange}
    >
      {config.label}
      <ChevronDown className="h-3.5 w-3.5" />
    </Button>
  )
}
